import PropTypes from 'prop-types'
import LinkDropdown from './LinkDropdown'
import {
  Body,
  Content,
  ContentImage,
  Header,
  HeaderTitle,
  ReadCopy,
  StyledBodyCopy,
  Wrapper,
} from './component.styles'

const ContentfulEntryCard = ({ className, contentfulEntry }) => {
  if (!contentfulEntry) return null
  const {
    header = '',
    image = {},
    bodyCopy = '',
    downloadLabel = '',
    downloadFiles = [],
    bodyCopy2 = '',
  } = contentfulEntry

  return (
    <Wrapper className={className}>
      <Header>
        <HeaderTitle>{header}</HeaderTitle>
      </Header>
      <Content>
        {image && (
          <ContentImage alt={image?.title || ''} src={image?.file?.url} />
        )}
        <Body>
          <StyledBodyCopy>{bodyCopy}</StyledBodyCopy>
          {downloadLabel && downloadFiles.length > 0 && (
            <LinkDropdown
              linkDropdownDisplayTitle={downloadLabel}
              linkMenu={downloadFiles}
            />
          )}
          {bodyCopy2 && <ReadCopy>{bodyCopy2}</ReadCopy>}
        </Body>
      </Content>
    </Wrapper>
  )
}

ContentfulEntryCard.propTypes = {
  className: PropTypes.string,
  contentfulEntry: PropTypes.shape({
    bodyCopy: PropTypes.string,
    bodyCopy2: PropTypes.string,
    downloadFiles: PropTypes.arrayOf(
      PropTypes.shape({
        internalTitle: PropTypes.string,
        displayTitle: PropTypes.string,
        file: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
        url: PropTypes.string,
      }),
    ),
    downloadLabel: PropTypes.string,
    header: PropTypes.string,
    image: PropTypes.object,
  }),
}

export default ContentfulEntryCard
